import { configureStore } from '@reduxjs/toolkit';

import { usersApi } from './features/users/userApi';
import { authApi } from './features/users/authApi';
import { departmentApi } from './features/departmentApi';
import { timeLogApi } from './features/timeLogApi';
import { settingsApi } from './features/settings/settingsApi';
import { clearUser, userReducer } from './features/slice/userSlice';
import { notificationApi } from './features/notificationApi';
import { firebaseApi } from './features/firebase/firebaseApi';
import { designationApi } from './features/designationApi';
import { holidayApi } from './features/holidayApi';
import { taxApi } from './features/taxApi';
import { salaryApi } from './features/salaryApi';
import { employeeLeaveApi } from './features/employeeLeaveApi';
import { bankDetailsApi } from './features/bankDetailsApi';
import { familyDetailsApi } from './features/familyDetailsApi';
import { employeeRulesApi } from './features/employeeRulesApi';
import { adminApi } from './features/admin/adminApi';
import { lunchBreakTrackApi } from './features/lunchBreakTrackApi';
import { employeePeriodsApi } from './features/employeePeriodsApi';
import { employeeBondApi } from './features/employeeBondApi';

export const rootReducer = {
  [usersApi.reducerPath]: usersApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [departmentApi.reducerPath]: departmentApi.reducer,
  [timeLogApi.reducerPath]: timeLogApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  [firebaseApi.reducerPath]: firebaseApi.reducer,
  [taxApi.reducerPath]: taxApi.reducer,
  [designationApi.reducerPath]: designationApi.reducer,
  [holidayApi.reducerPath]: holidayApi.reducer,
  [salaryApi.reducerPath]: salaryApi.reducer,
  [employeeLeaveApi.reducerPath]: employeeLeaveApi.reducer,
  [bankDetailsApi.reducerPath]: bankDetailsApi.reducer,
  [familyDetailsApi.reducerPath]: familyDetailsApi.reducer,
  [employeeRulesApi.reducerPath]: employeeRulesApi.reducer,
  [adminApi.reducerPath]: adminApi.reducer,
  [lunchBreakTrackApi.reducerPath]: lunchBreakTrackApi.reducer,
  [employeePeriodsApi.reducerPath]: employeePeriodsApi.reducer,
  [employeeBondApi.reducerPath]: employeeBondApi.reducer,

  user: userReducer,
};

export const commonMiddleware = (getDefaultMiddleware) =>
  getDefaultMiddleware()
    .concat(usersApi.middleware)
    .concat(authApi.middleware)
    .concat(timeLogApi.middleware)
    .concat(departmentApi.middleware)
    .concat(firebaseApi.middleware)
    .concat(settingsApi.middleware)
    .concat(notificationApi.middleware)
    .concat(taxApi.middleware)
    .concat(designationApi.middleware)
    .concat(holidayApi.middleware)
    .concat(salaryApi.middleware)
    .concat(employeeLeaveApi.middleware)
    .concat(bankDetailsApi.middleware)
    .concat(familyDetailsApi.middleware)
    .concat(employeeRulesApi.middleware)
    .concat(adminApi.middleware)
    .concat(lunchBreakTrackApi.middleware)
    .concat(employeePeriodsApi.middleware)
    .concat(employeeBondApi.middleware);

export const store = configureStore({
  reducer: rootReducer,
  middleware: commonMiddleware,
});

const clearStore = () => {
  store.dispatch(usersApi.util.resetApiState());
  store.dispatch(authApi.util.resetApiState());
  store.dispatch(departmentApi.util.resetApiState());
  store.dispatch(timeLogApi.util.resetApiState());
  store.dispatch(settingsApi.util.resetApiState());
  store.dispatch(notificationApi.util.resetApiState());
  store.dispatch(clearUser());
  store.dispatch(firebaseApi.util.resetApiState());
  store.dispatch(taxApi.util.resetApiState());
  store.dispatch(designationApi.util.resetApiState());
  store.dispatch(holidayApi.util.resetApiState());
  store.dispatch(salaryApi.util.resetApiState());
  store.dispatch(employeeLeaveApi.util.resetApiState());
  store.dispatch(bankDetailsApi.util.resetApiState());
  store.dispatch(familyDetailsApi.util.resetApiState());
  store.dispatch(employeeRulesApi.util.resetApiState());
  store.dispatch(adminApi.util.resetApiState());
  store.dispatch(lunchBreakTrackApi.util.resetApiState());
  store.dispatch(employeePeriodsApi.util.resetApiState());
  store.dispatch(employeeBondApi.util.resetApiState());
};

export { clearStore };
